<template>
    <card-form
            class="card-form_max-xs transfer"
            :class="{
                'transfer_mobile': isMobile
            }"
            :validator="$validator"
            :form-errors.sync="errors"
            :model.sync="model"
            label-create="msg.createTransfer"
            action-create="createTransfer"
            action-edit="editTransfer"
            action-load="loadTransfer"
            route-edit="edit_transfer"
            success-route="transactions"
            :before-submit="beforeSubmit"
    >
        <template v-slot:before-btn>
            <v-btn
                    v-if="!!id"
                    color="error"
                    @click="deleteModel()"
                    :disabled="deleteLoading"
                    :loading="deleteLoading"
                    small
                    elevation="0"
            >{{ $t('msg.delete') }}</v-btn>
        </template>
        <v-card class="mt-4">
            <v-card-text
                    :class="{'c-pa-10': $vuetify.breakpoint.xsOnly}"
            >
                <div class="transfer__item">
                    <div class="transfer__from">
                        <v-autocomplete
                                v-model="model.account_id_from"
                                :label="$t('msg.fromAccount')"
                                :error-messages="errors.collect('account_id_from')"
                                data-vv-name="account_id_from"
                                v-validate="'required'"
                                :items="getAccounts"
                                item-value="id"
                                item-text="name"
                                :loading="accountsLoading"
                                @change="changeSumTo()"
                                outlined
                                :dense="!isMobile"
                                hide-details="auto"
                        ></v-autocomplete>
                    </div>
                    <div class="transfer__arrow">
                        <v-icon color="primary">mdi-arrow-right-bold</v-icon>
                    </div>
                    <div class="transfer__to">
                        <v-autocomplete
                                v-model="model.account_id_to"
                                :label="$t('msg.toAccount')"
                                :error-messages="errors.collect('account_id_to')"
                                data-vv-name="account_id_to"
                                v-validate="'required'"
                                :items="filteredAccounts"
                                item-value="id"
                                item-text="name"
                                :loading="accountsLoading"
                                @change="changeSumTo()"
                                outlined
                                :dense="!isMobile"
                                hide-details="auto"
                        ></v-autocomplete>
                    </div>
                </div>

                <div class="transfer__item mt-3">
                    <div class="transfer__from">
                        <v-text-field
                                :label="$t('msg.sumFromAccount')"
                                v-model.number="model.val_from"
                                :error-messages="errors.collect('val')"
                                data-vv-name="val"
                                v-validate="'required|min_value:0.01'"
                                type="number"
                                outlined
                                :dense="!isMobile"
                                hide-details="auto"
                                @change="changeSumTo()"
                        ></v-text-field>
                    </div>
                    <div class="transfer__arrow">
                        <v-icon color="primary">mdi-arrow-right-bold</v-icon>
                    </div>
                    <div class="transfer__to">
                        <v-text-field
                                :label="$t('msg.sumToAccount')"
                                v-model.number="model.val_to"
                                :error-messages="errors.collect('val')"
                                data-vv-name="val"
                                v-validate="'required|min_value:0.01'"
                                type="number"
                                outlined
                                :dense="!isMobile"
                                hide-details="auto"
                                :disabled="oneCurrency"
                        ></v-text-field>
                    </div>
                </div>
                <v-text-field
                        :label="$t('msg.name')"
                        v-model="model.name"
                        :error-messages="errors.collect('name')"
                        data-vv-name="name"
                        v-validate="'max:255'"
                        outlined
                        :dense="!isMobile"
                        hide-details
                        class="mt-3"
                ></v-text-field>
                <v-dialog width="290">
                    <template v-slot:activator="{ on }">
                        <v-text-field
                                :value="dateString(model._date)"
                                :error-messages="errors.collect('date')"
                                data-vv-name="date"
                                :label="$t('msg.date')"
                                readonly
                                clearable
                                v-on="on"
                                v-validate="'required'"
                                outlined
                                :dense="!isMobile"
                                hide-details
                                class="mt-3"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                            v-model="model._date"
                            scrollable
                            :locale="$store.getters.lang"
                            :first-day-of-week="1"
                    ></v-date-picker>
                </v-dialog>
                <v-combobox
                        v-model="model.tag"
                        :label="$t('msg.markers')"
                        :error-messages="errors.collect('tags')"
                        data-vv-name="tags"
                        multiple
                        small-chips
                        hide-selected
                        clearable
                        deletable-chips
                        outlined
                        :dense="!isMobile"
                        hide-details
                        class="mt-3"
                ></v-combobox>
            </v-card-text>
        </v-card>
    </card-form>
</template>

<script>
    import { format } from 'date-fns';

    export default {
        data() {
            return {
                id: null,
                formLoading: false,
                modelLoading: false,
                model: {
                    account_id_from: null,
                    account_id_to: null,
                    name: null,
                    val_from: null,
                    val_to: null,
                    date: null,
                    _date: format(new Date(), 'yyyy-MM-dd'),
                    tag: []
                },
                accounts: [],
                accountsLoading: false,
                currencies: [],
                deleteLoading: false
            }
        },
        computed: {
            filteredAccounts() {
                return this.getAccounts.filter(item => {

                    let same = () => {
                        return this.model.account_id_from !== item.id;
                    };

                    return same();
                })
            },
            oneCurrency() {
                if (this.model.account_id_from && this.model.account_id_to) {
                    let from = this.accounts.find(v => v.id === this.model.account_id_from);
                    let to = this.accounts.find(v => v.id === this.model.account_id_to);

                    if (from.currency_id === to.currency_id) {
                        return true;
                    }
                }

                return false;
            },
            getAccounts() {
                let items = [];

                this.accounts.forEach(item => {

                    let currency = '';

                    const cur = this.currencies.find(v => v.id === item.currency_id);
                    if (cur !== undefined) currency = cur.symbol;

                    items.push({
                        id: item.id,
                        name: item.name + ' (' + this.$options.filters.numFormat(item.balance, '0,0.00') + ' ' + currency + ')'
                    });
                });

                return items;
            }
        },
        watch: {
            model() {
                this.loadedModel();
            }
        },
        methods: {
            changeSumTo() {
                if (this.oneCurrency) {
                    this.model.val_to = this.model.val_from;
                }
            },
            loadedModel() {
                let date = this.model.date.substring(0, 10);

                this.model._date = date;
                this.$store.commit('setBreadcrumbs', [{id: 2, name: date + ' (' + this.model.val + ')'}]);
            },
            loadAccounts() {
                this.accountsLoading = true;
                this.$store.dispatch('loadAccounts')
                    .then(res => this.accounts = res)
                    .finally(() => this.accountsLoading = false);
            },
            loadCurrencies() {
                this.$store.dispatch('loadCurrencies')
                    .then(res => this.currencies = res);
            },
            beforeSubmit(model) {
                model.date = model._date + 'T00:00:00Z';
            },
            deleteModel() {
                if (!confirm(this.$t('msg.deleteQuestion'))) return;

                this.deleteLoading = true;

                this.$store.dispatch('deleteTransaction', {id: this.id})
                    .then(() => {
                        this.$router.push({name: 'transactions'});
                    })
                    .finally(() => this.deleteLoading = false);
            }
        },
        created() {
            this.loadAccounts();
            this.loadCurrencies();

            this.id = parseInt(this.$route.params.id);

            if (!this.id) {

                if (this.$route.query.date) {
                    this.model._date = this.$route.query.date;
                }

                if (this.$route.query.account_id) {
                    this.model.account_id_to = parseInt(this.$route.query.account_id);
                }
            }
        }
    }
</script>

<style lang="scss">
    .transfer {
        &.transfer_mobile {
            .transfer__item {
                flex-direction: column;
            }
            .transfer__from {
                width: 100%;
            }
            .transfer__to {
                width: 100%;
            }
            .transfer__arrow {
                width: 100%;
                padding-bottom: 7px;

                .v-icon {
                    transform: rotate(90deg);
                }
            }
        }
        .transfer__item {
            display: flex;
            align-items: flex-start;
        }
        .transfer__from {
            width: calc(50% - 20px);
        }
        .transfer__arrow {
            width: 40px;
            display: flex;
            justify-content: center;
            padding-top: 7px;
        }
        .transfer__to {
            width: calc(50% - 20px);
        }
    }
</style>